import * as React from 'react'
import InsuranceProviderSection from '../InsuranceProviders/InsuranceProvidersSection'

export const InsurersView: React.FC = () => <InsuranceProviderSection />
